import React, { useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AddCaseIcon,
  AddDomainIcon,
  Button,
  Flags,
  GroupAddIcon,
  PlusIcon,
  PopoverMenu,
  UploadFileIcon,
  useFlag,
} from 'ui';
import { InvitationModalsOrchestrator } from '@components/InvitationModalsOrchestrator';
import { useUserOrgCase } from '@context/UserOrgCaseContext';
import { PATHS } from '@utils/paths';

export function AddOptionsButton() {
  const isUploadClaimsFileEnabled = useFlag(Flags.uploadClaimsFile);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const navigate = useNavigate();
  const anchorEl = useRef<HTMLButtonElement>(null);

  const { selectedOrganization } = useUserOrgCase();

  const [inviteOrgModalOpen, setInviteOrgModalOpen] = useState(false);
  const [inviteUserModalOpen, setInviteUserModalOpen] = useState(false);

  const menuOptions = useMemo(
    () => [
      {
        onClick: () => {
          navigate(
            `${PATHS.PRIVATE_BASE.newCaseCreation}?orgId=${selectedOrganization.organizationID}`,
            { state: { previousUrl: location.pathname } },
          );
        },
        icon: <AddCaseIcon />,
        iconPosition: 'start' as const,
        title: 'Create New Case',
      },
      {
        divider: true,
      },
      {
        onClick: () => setInviteOrgModalOpen(true),
        iconPosition: 'start' as const,
        icon: <AddDomainIcon />,
        title: 'Add Organization Member',
      },
      {
        onClick: () => setInviteUserModalOpen(true),
        iconPosition: 'start' as const,
        icon: <GroupAddIcon />,
        title: 'Add Case Member',
      },
      {
        divider: true,
      },
      {
        onClick: () => {
          navigate(
            `${PATHS.PRIVATE_BASE.uploadClaimsFile}?orgId=${selectedOrganization.organizationID}`,
            { state: { previousUrl: location.pathname } },
          );
        },
        icon: <UploadFileIcon />,
        iconPosition: 'start' as const,
        title: 'Upload Claims File',
        disabled: !isUploadClaimsFileEnabled,
      },
    ],
    [isUploadClaimsFileEnabled, navigate, selectedOrganization.organizationID],
  );

  return (
    <>
      <Button
        aria-label="Add Options Dropdown"
        color="neutral"
        onClick={() => {
          setIsPopoverOpen((prev) => !prev);
        }}
        ref={anchorEl}
        startIcon={<PlusIcon />}
        variant="text"
      />
      <PopoverMenu
        anchorEl={anchorEl.current}
        isOpen={isPopoverOpen}
        menuItems={menuOptions}
        onClose={() => {
          setIsPopoverOpen(false);
        }}
      />
      <InvitationModalsOrchestrator
        inviteOrgModalOpen={inviteOrgModalOpen}
        inviteUserModalOpen={inviteUserModalOpen}
        setInviteOrgModalOpen={setInviteOrgModalOpen}
        setInviteUserModalOpen={setInviteUserModalOpen}
      />
    </>
  );
}
